<template>
  <div class="scm-body">
    <div class="scm-main">
      <div class="scm-left">
        <span class="en-title">Digital supply chain collaboration platform for avocado</span>
        <p class="title"><b>牛油果</b>数字供应链协同平台</p>
        <p class="desc">
          围绕牛油果种植、采收、分选、品控、物流运输、订单管理等产地供应链核心环节，实现数字化产供销协同，形成生产规范、降低生产成本、提高牛油果商品化率及供应链服务能力。
        </p>
        <div class="tools">
          <div class="item" v-for="(item,index) in tools" :key="index">
            <img :src="item.icon" />
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
      <div class="scm-right">
        <div class="img-box">
          <img src="@/assets/scm/bg.png" />
          <a class="bottom" href="https://scm.ynnyg.com" target="_blank">
            <div class="en-title">Enter the system</div>
            <div class="title">进入系统</div>
            <div class="arrow">
              <img src="@/assets/scm/arrow.svg" />
            </div>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SCM',
  data(){
    return {
      tools:[{id:1,title:'订单管理',icon:require('@/assets/scm/ddgl.svg')},{id:2,title:'仓储管理',icon:require('@/assets/scm/ccgl.svg')},
        {id:3,title:'客户管理',icon:require('@/assets/scm/khgl.svg')},{id:4,title:'供应商管理',icon:require('@/assets/scm/gysgl.svg')}]
    }
  }
}
</script>
<style>
.scm-body {
  padding: 50px 0;
  max-width: 1200px;
  margin: 0 auto;
}
.scm-main {
  width: 100%;
  border-radius: 40px;
  background: linear-gradient(180deg, rgba(203, 216, 255, 0.23) 0%, rgba(203, 216, 255, 0.11) 100%);
  padding: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.scm-main .scm-left {
  flex: 1;
  max-width: 550px;
  padding-right: 50px;
}
.scm-main .scm-right {
  flex: 1;
  padding-left: 50px;
}
.scm-main .scm-left .en-title {
  color: #637385;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.scm-main .scm-left .title {
  color: #637385;
  font-size: 36px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 5px;
}
.scm-main .scm-left .title b {font-size: 36px;}
.scm-main .scm-left .desc {
  color: #637385;
  text-align: justify;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px; /* 208.333% */
  margin-top: 30px;
}
.scm-main .scm-left .tools {
  display: flex;
  flex-direction: row;
  //margin-top: 20px;
}
.scm-main .scm-left .tools .item {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: #14AB39;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.scm-main .scm-left .tools .item span {font-size: 16px;}
.scm-main .scm-right .img-box {
  display: flex;flex-direction: column;
  width: 100%;
  background: #B3BFE2;
  border-radius: 15px;
  overflow: hidden;
}
.scm-main .scm-right .img-box .bottom {
  background: #B3BFE2;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.scm-main .scm-right .img-box .bottom .en-title {
  color: #fff;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  display: flex;
  text-transform: uppercase;
  scale: .7;
  flex: 1;
}
.scm-main .scm-right .img-box .bottom .title {
  color: #fff;
  font-size: 20px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 600;
  flex: 1;
}
.scm-main .scm-right .img-box .bottom:hover {
  background: #97A9DF;
  cursor: pointer;
}
.scm-main .scm-right .img-box .bottom:hover .arrow >img {
  width: 60px;
}
.scm-main .scm-right .img-box .bottom .arrow {
  color: #fff;
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
}
.scm-main .scm-right .img-box .bottom .arrow >img {
  transition: all linear .3s;
  width: 37px;
}
.scm-main .scm-right .img-box > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/SCM.vue